import React from 'react';
import Header from '../../../components/header';
import MembershipList from './membership-card';

import { useLanguage } from '../../../helpers/language-context';

const Membership = () => {
  const { translations } = useLanguage();
  return (
    <div className="membership-container">
      <Header title={translations.about.membership} flip={true} bgImg="/assets/images/header-bg/bg_membership.png" />
      <section className="bg-[#F2F2F2] p-8 md:p-16 lg:p-24">
        <MembershipList />
      </section>
    </div>
  );
};

export default Membership;
